import { render, staticRenderFns } from "./projectManagement.vue?vue&type=template&id=05970edf&scoped=true"
import script from "./projectManagement.vue?vue&type=script&lang=js"
export * from "./projectManagement.vue?vue&type=script&lang=js"
import style0 from "./projectManagement.vue?vue&type=style&index=0&id=05970edf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05970edf",
  null
  
)

export default component.exports